"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangeInput = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireDefault(require("react"));
var _calendar = require("../../../../assets/icons/calendar.svg");
var _caretDown = require("../../../../assets/icons/caret-down.svg");
var _close = require("../../../../assets/icons/close.svg");
var _dateRangeInputModule = _interopRequireDefault(require("./date-range-input.module.scss"));
var _classnames6 = _interopRequireDefault(require("classnames"));
var _dateFns = require("date-fns");
var _format = require("../../../../utils/dates/format");
var _useDateValidation = require("../../hooks/useDateValidation");
var _useTranslation2 = require("../../../../hooks/useTranslation/useTranslation");
var DateRangeInput = function DateRangeInput(_ref) {
  var _classnames, _classnames5;
  var onClick = _ref.onClick,
    onIconClick = _ref.onIconClick,
    onClearClick = _ref.onClearClick,
    disabled = _ref.disabled,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    startDateId = _ref.startDateId,
    endDateId = _ref.endDateId,
    startDateRef = _ref.startDateRef,
    endDateRef = _ref.endDateRef,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    onChange = _ref.onChange,
    _ref$startDateValue = _ref.startDateValue,
    startDateValue = _ref$startDateValue === void 0 ? '' : _ref$startDateValue,
    _ref$endDateValue = _ref.endDateValue,
    endDateValue = _ref$endDateValue === void 0 ? '' : _ref$endDateValue,
    onDateChange = _ref.onDateChange;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  (0, _useDateValidation.useDateValidation)(startDateId);
  (0, _useDateValidation.useDateValidation)(endDateId);
  var handleClearClick = function handleClearClick(e) {
    e.stopPropagation();
    onDateChange([null, null]);
    onChange({
      currentTarget: {
        value: ''
      },
      target: {
        value: ''
      }
    });
    onClearClick(e);
  };
  var onStartDateChange = function onStartDateChange(e) {
    var newStartValue = e.currentTarget.value;
    var newValue = newStartValue === '' ? '' : "".concat(newStartValue, " - ").concat(endDateValue);
    var parsedStart = (0, _dateFns.parse)(newStartValue, _format.shortDateFormat, new Date());
    var parsedEnd = (0, _dateFns.parse)(endDateValue, _format.shortDateFormat, new Date());
    if (newStartValue === '') {
      onDateChange([null, null]);
    } else if (newStartValue.length === _format.shortDateFormat.length && (0, _dateFns.isValid)(parsedStart) && ((0, _dateFns.isSameDay)(parsedStart, parsedEnd) || (0, _dateFns.isBefore)(parsedStart, parsedEnd))) {
      onDateChange([parsedStart, parsedEnd]);
    }
    onChange({
      currentTarget: {
        value: newValue
      },
      target: {
        value: newValue
      }
    });
  };
  var onEndDateChange = function onEndDateChange(e) {
    var newEndValue = e.currentTarget.value;
    var newValue = "".concat(startDateValue, " - ").concat(newEndValue);
    var parsedStart = (0, _dateFns.parse)(startDateValue, _format.shortDateFormat, new Date());
    var parsedEnd = (0, _dateFns.parse)(newEndValue, _format.shortDateFormat, new Date());
    if (newEndValue === '') {
      onDateChange([parsedStart, null]);
    } else if (newEndValue.length === _format.shortDateFormat.length && (0, _dateFns.isValid)(parsedEnd) && ((0, _dateFns.isSameDay)(parsedStart, parsedEnd) || (0, _dateFns.isBefore)(parsedStart, parsedEnd))) {
      onDateChange([parsedStart, parsedEnd]);
    }
    onChange({
      currentTarget: {
        value: newValue
      },
      target: {
        value: newValue
      }
    });
  };
  var onFocus = function onFocus() {
    onClick();
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_dateRangeInputModule.default['date-range-input'], _dateRangeInputModule.default['date-range-input--focused'], (_classnames = {}, (0, _defineProperty2.default)(_classnames, _dateRangeInputModule.default['date-range-input--error'], error), (0, _defineProperty2.default)(_classnames, _dateRangeInputModule.default['date-range-input--small'], small), _classnames))
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: disabled ? undefined : function (e) {
      return onIconClick(e);
    },
    className: (0, _classnames6.default)(_dateRangeInputModule.default['date-range-input__icon'], (0, _defineProperty2.default)({}, _dateRangeInputModule.default['date-range-input__icon--clickable'], !disabled))
  }, /*#__PURE__*/_react.default.createElement(_calendar.ReactComponent, {
    "data-testid": "calendar-icon",
    className: "react-datepicker-ignore-onclickoutside"
  })), /*#__PURE__*/_react.default.createElement("input", {
    id: startDateId,
    "data-testid": startDateId,
    autoComplete: 'off',
    value: startDateValue,
    disabled: disabled,
    onFocus: onFocus,
    className: (0, _classnames6.default)(_dateRangeInputModule.default['date-range-input__input'], 'react-datepicker-ignore-onclickoutside', (0, _defineProperty2.default)({}, _dateRangeInputModule.default['date-range-input__input--small'], small)),
    onChange: onStartDateChange,
    ref: startDateRef
    // @ts-ignore-next
    ,
    placeholder: t('date.startDate')
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _dateRangeInputModule.default['date-range-input__separator']
  }, t('date.rangeSeparator')), /*#__PURE__*/_react.default.createElement("input", {
    id: endDateId,
    "data-testid": endDateId,
    autoComplete: 'off',
    value: endDateValue,
    disabled: disabled,
    onFocus: onFocus,
    className: (0, _classnames6.default)(_dateRangeInputModule.default['date-range-input__input'], 'react-datepicker-ignore-onclickoutside', (0, _defineProperty2.default)({}, _dateRangeInputModule.default['date-range-input__input--small'], small)),
    onChange: onEndDateChange,
    ref: endDateRef,
    placeholder: t('date.endDate')
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_dateRangeInputModule.default['date-range-input__suffix-icon'], 'react-datepicker-ignore-onclickoutside', (_classnames5 = {}, (0, _defineProperty2.default)(_classnames5, _dateRangeInputModule.default['date-range-input__suffix-icon--clickable'], !disabled), (0, _defineProperty2.default)(_classnames5, _dateRangeInputModule.default['date-range-input__suffix-icon--inline'], inline), (0, _defineProperty2.default)(_classnames5, _dateRangeInputModule.default['date-range-input__suffix-icon--small'], small), _classnames5)),
    onClick: disabled ? undefined : function (e) {
      return startDateValue !== '' || endDateValue !== '' ? handleClearClick(e) : onIconClick(e);
    }
  }, startDateValue !== '' || endDateValue !== '' ? /*#__PURE__*/_react.default.createElement(_close.ReactComponent, {
    "data-testid": "clear-icon"
  }) : /*#__PURE__*/_react.default.createElement(_caretDown.ReactComponent, {
    "data-testid": "caret-down-icon"
  })));
};
exports.DateRangeInput = DateRangeInput;